var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Table',{staticClass:"deploy-table",attrs:{"columns":_vm.colList,"data":_vm.statusList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }